// Vuetify Documentation https://vuetifyjs.com

import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import { themePreset } from "@/themeConfig";

import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  // breakpoint: themePreset.breakpoint,
  theme: themePreset.theme,
  rtl: themePreset.rtl,
  lang: {
    locales: {
      pt,
    },
    current: "pt",
  },
});
